// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__17MUu","imageUploader":"EGiftCard_imageUploader__CYk7G"};